import React, { useState, useEffect, memo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useParams } from "react-router-dom";
import { toastError } from "../../../utils";
import VesselAnalysisEstimationTab from "./VesselAnalysisEstimationTab";
import * as vesselAnalysisActions from "./actions";

const useStyles = makeStyles((theme) => ({
  root: { width: "100%" },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    color: "#666",
  },
}));

function VesselAnalysisEstimation(props) {
  const { setLoader = () => { }, setIsFullScreen = () => { }, loader = false } = props;
  const classes = useStyles();
  const { vesselAnalysisId } = useParams();

  const [currentAnalysis, setCurrentAnalysis] = useState(null);

  useEffect(() => {
    setIsFullScreen(true);
    fetchAnalysis();
    return () => setIsFullScreen(false);
  }, [vesselAnalysisId]);

  const fetchAnalysis = async () => {
    if (!vesselAnalysisId) return;
    setLoader(true);
    try {
      const singleRes = await vesselAnalysisActions.getVesselCargoAnalysisById(vesselAnalysisId);
      const analysis = singleRes?.data;
      if (!analysis) {
        setLoader(false);
        return;
      }
      setCurrentAnalysis(analysis);
    } catch (err) {
      toastError(err?.data?.message || "Failed to load Estimation analysis");
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className={`${classes.root} vessel-analysis-page`}>
      {currentAnalysis ? (
        <VesselAnalysisEstimationTab
          analysis={currentAnalysis}
          setLoader={setLoader}
          loader={loader}
        />
      ) : null}
    </div>
  );
}

export default memo(VesselAnalysisEstimation);
